// El login informa de los departamentos cuyos tickets gestiona el usuario, pero la sesión se
// mantiene con el refresh token y ese dato quedaría congelado en el navegador. Al arrancar se
// renueva con lo que devuelve GET /api/me/permissions.
export const applyManagedDepartments = (user, managedDepartments) => {
  // Un back que no lo informa no dice nada: se conserva lo que ya hay
  if (!Array.isArray(managedDepartments)) return user;

  const rest = { ...user };
  delete rest.managedDepartments;
  delete rest.departmentManager;
  if (!managedDepartments.length) return rest;

  // departmentManager se mantiene como compatibilidad con el front que lo usa como flag
  return { ...rest, managedDepartments, departmentManager: managedDepartments[0] };
};
